import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { User, User as UserModel } from "../../../models/user";
import * as UserApi from "../../../network/user_api";
import TextInputFieldInline from "../../../components/FormFields/TextInputFieldInline";
import { useTranslation } from "react-i18next";
import ActionButton from "../../../components/Buttons/Action/ActionButton";

interface EditProfileProps {
  user: UserModel;
  onProfileSaved: (user: UserModel) => void;
}

const EditProfile = ({ user, onProfileSaved }: EditProfileProps) => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<User>({
    defaultValues: {
      firstName: user?.firstName || "",
      lastName: user?.lastName || "",
      email: user?.email || "",
      userName: user?.userName || "",
      password: user?.password || "",
      xp: 0,
    },
  });

  async function onProfileSubmit(data: User) {
    try {
      const updatedUser = await UserApi.updateUser(data);
      onProfileSaved(updatedUser);
    } catch (error) {
      console.error(error);
      alert(error);
    }
  }

  return (
    <Form id="updateUserData" onSubmit={handleSubmit(onProfileSubmit)}>
      <Form.Group className="center-content">
        <TextInputFieldInline
          name="firstName"
          label={t("common.firstName")}
          type="firstName"
          placeholder={user.firstName}
          register={register}
          error={errors.firstName}
        />
        <TextInputFieldInline
          name="lastName"
          label={t("common.lastName")}
          type="lastName"
          placeholder={user.lastName}
          register={register}
          error={errors.lastName}
        />
        <TextInputFieldInline
          name="email"
          label={t("common.email")}
          type="email"
          placeholder={user.email}
          register={register}
          error={errors.email}
        />
        <TextInputFieldInline
          name="userName"
          label={t("common.username")}
          type="userName"
          placeholder={user.userName}
          register={register}
          error={errors.userName}
        />
        <TextInputFieldInline
          name="password"
          label={t("common.password")}
          type="password"
          placeholder="●●●●●●●●●●"
          register={register}
          error={errors.password}
        />
      </Form.Group>
      <div className="button-container">
        <ActionButton form="updateUserData" type="submit">
          {t("common.save")}
        </ActionButton>
      </div>
    </Form>
  );
};

export default EditProfile;
